export default "__VITE_ASSET__d45bf41a__"